import React from "react";
import { CHEVRON_RIGHT_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../AppIcon";

const TrailingChevron = () => {
  return (
    <div className="TrailingChevron">
      <AppIcon icon={CHEVRON_RIGHT_ICON} size={10} fill="#D6D6D6" />
    </div>
  );
};

export default React.memo(TrailingChevron);
